<template>
  <div class="form-edit-page">
    <div class="page-header">
      <h1>Gestão de Processos por Município</h1>
      <p>
        Acompanhamento centralizado de registros de estabelecimentos, produtos e rótulos
        no departamento de inspeção.
      </p>
    </div>

    <!-- FILTROS -->
    <div class="form-card">
      <div class="card-title">Filtros de Consulta</div>

      <div class="row">
        <div class="field">
          <label>Município</label>
          <select v-model="filtros.idMunicipio">
            <option value="">Todos</option>
            <option
              v-for="municipio in municipios"
              :key="municipio.id"
              :value="municipio.id"
            >
              {{ municipio.nome }}
            </option>
          </select>
        </div>

        <div class="field">
          <label>Tipo</label>
          <select v-model="filtros.tipo">
            <option value="">Todos</option>
            <option value="ESTABELECIMENTO">Registro de Estabelecimento</option>
            <option value="PRODUTO">Registro de Produto</option>
            <option value="ROTULO">Registro de Rótulo</option>
            <option value="PROCESSO_ADMINISTRATIVO">Processo Administrativo</option>
          </select>
        </div>

        <div class="field">
          <label>Situação</label>
          <select v-model="filtros.situacao">
            <option value="">Todas</option>
            <option value="EM_ANALISE">Em análise</option>
            <option value="PENDENTE">Pendente</option>
            <option value="DEFERIDO">Deferido</option>
            <option value="INDEFERIDO">Indeferido</option>
            <option value="CANCELADO">Cancelado</option>
          </select>
        </div>

        <div class="field field-grow">
          <label>Pesquisar</label>
          <input
            v-model="filtros.texto"
            type="text"
            placeholder="Número do processo, estabelecimento, produto, rótulo..."
          />
        </div>
      </div>

      <div class="row row-actions">
        <button class="btn btn-primary" @click="aplicarFiltros">Atualizar visão</button>
        <button class="btn btn-secondary" @click="limparFiltros">Limpar</button>
      </div>
    </div>

    <!-- INDICADORES -->
    <div class="kpi-grid">
      <div class="kpi-card">
        <div class="kpi-title">Total de Processos</div>
        <div class="kpi-value">{{ indicadores.total }}</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-title">Em Análise</div>
        <div class="kpi-value">{{ indicadores.emAnalise }}</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-title">Pendentes</div>
        <div class="kpi-value">{{ indicadores.pendentes }}</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-title">Deferidos</div>
        <div class="kpi-value">{{ indicadores.deferidos }}</div>
      </div>
    </div>

    <!-- LISTA -->
    <div class="form-card">
      <div class="card-title">Registros e Processos</div>

      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Município</th>
              <th>Tipo</th>
              <th>Nº Processo</th>
              <th>Estabelecimento</th>
              <th>Produto / Rótulo</th>
              <th>Situação</th>
              <th>Responsável</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in listaFiltrada"
              :key="item.id"
              @click="selecionarItem(item)"
              :class="{ selected: itemSelecionado && itemSelecionado.id === item.id }"
            >
              <td>{{ item.municipio }}</td>
              <td>{{ formatarTipo(item.tipo) }}</td>
              <td>{{ item.numeroProcesso }}</td>
              <td>{{ item.estabelecimento }}</td>
              <td>{{ item.referencia }}</td>
              <td>
                <span class="status-pill" :class="statusClass(item.situacao)">
                  {{ formatarSituacao(item.situacao) }}
                </span>
              </td>
              <td>{{ item.responsavel }}</td>
              <td>{{ item.data }}</td>
            </tr>

            <tr v-if="listaFiltrada.length === 0">
              <td colspan="8" class="empty-row">
                Nenhum registro encontrado para os filtros informados.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- DETALHE -->
    <div class="form-card" v-if="itemSelecionado">
      <div class="card-title">Detalhamento do Processo / Registro</div>

      <div class="detail-grid">
        <div class="detail-box">
          <div class="detail-label">Município</div>
          <div class="detail-value">{{ itemSelecionado.municipio }}</div>
        </div>

        <div class="detail-box">
          <div class="detail-label">Tipo</div>
          <div class="detail-value">{{ formatarTipo(itemSelecionado.tipo) }}</div>
        </div>

        <div class="detail-box">
          <div class="detail-label">Número</div>
          <div class="detail-value">{{ itemSelecionado.numeroProcesso }}</div>
        </div>

        <div class="detail-box">
          <div class="detail-label">Situação</div>
          <div class="detail-value">
            {{ formatarSituacao(itemSelecionado.situacao) }}
          </div>
        </div>

        <div class="detail-box">
          <div class="detail-label">Estabelecimento</div>
          <div class="detail-value">{{ itemSelecionado.estabelecimento }}</div>
        </div>

        <div class="detail-box">
          <div class="detail-label">Referência</div>
          <div class="detail-value">{{ itemSelecionado.referencia }}</div>
        </div>

        <div class="detail-box">
          <div class="detail-label">Responsável</div>
          <div class="detail-value">{{ itemSelecionado.responsavel }}</div>
        </div>

        <div class="detail-box">
          <div class="detail-label">Data</div>
          <div class="detail-value">{{ itemSelecionado.data }}</div>
        </div>
      </div>

      <div class="row">
        <div class="field field-grow">
          <label>Pendências</label>
          <textarea
            rows="4"
            v-model="itemSelecionado.pendencias"
            readonly
          ></textarea>
        </div>
      </div>

      <div class="row">
        <div class="field field-grow">
          <label>Observações</label>
          <textarea
            rows="4"
            v-model="itemSelecionado.observacoes"
            readonly
          ></textarea>
        </div>
      </div>

      <div class="subsection">
        <h3>Histórico de Tramitação</h3>
        <div class="timeline">
          <div
            class="timeline-item"
            v-for="(hist, index) in itemSelecionado.historico"
            :key="index"
          >
            <div class="timeline-date">{{ hist.data }}</div>
            <div class="timeline-content">
              <strong>{{ hist.titulo }}</strong>
              <p>{{ hist.descricao }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'

const municipios = ref([
  { id: 1, nome: 'Araranguá' },
  { id: 2, nome: 'Sombrio' },
  { id: 3, nome: 'Balneário Arroio do Silva' },
  { id: 4, nome: 'Maracajá' }
])

const filtros = reactive({
  idMunicipio: '',
  tipo: '',
  situacao: '',
  texto: ''
})

const lista = ref([
  {
    id: 1,
    municipioId: 1,
    municipio: 'Araranguá',
    tipo: 'ESTABELECIMENTO',
    numeroProcesso: 'PROC-2026/0012',
    estabelecimento: 'Agroindústria Sabor Colonial',
    referencia: 'Registro inicial do estabelecimento',
    situacao: 'EM_ANALISE',
    responsavel: 'Departamento de Inspeção',
    data: '18/03/2026',
    pendencias: 'Apresentar ART atualizada e complementar o mapa de produção.',
    observacoes: 'Processo protocolado pelo portal e aguardando análise documental.',
    historico: [
      { data: '15/03/2026 09:10', titulo: 'Protocolo', descricao: 'Solicitação registrada no portal.' },
      { data: '16/03/2026 14:25', titulo: 'Triagem', descricao: 'Documentos conferidos parcialmente.' },
      { data: '18/03/2026 10:40', titulo: 'Pendência', descricao: 'Solicitada complementação documental.' }
    ]
  },
  {
    id: 2,
    municipioId: 2,
    municipio: 'Sombrio',
    tipo: 'PRODUTO',
    numeroProcesso: 'PROC-2026/0031',
    estabelecimento: 'Laticínios Serra Sul',
    referencia: 'Queijo Colonial Tradicional',
    situacao: 'PENDENTE',
    responsavel: 'Fiscal Simone',
    data: '17/03/2026',
    pendencias: 'Ajustar composição e anexar memorial descritivo.',
    observacoes: 'Produto vinculado a estabelecimento já registrado.',
    historico: [
      { data: '17/03/2026 08:30', titulo: 'Cadastro', descricao: 'Produto incluído para análise.' },
      { data: '17/03/2026 16:05', titulo: 'Pendência técnica', descricao: 'Necessário ajuste de formulação.' }
    ]
  },
  {
    id: 3,
    municipioId: 1,
    municipio: 'Araranguá',
    tipo: 'ROTULO',
    numeroProcesso: 'PROC-2026/0040',
    estabelecimento: 'Apiário Vale do Mel',
    referencia: 'Rótulo Mel Silvestre 500g',
    situacao: 'DEFERIDO',
    responsavel: 'Fiscal Marcos',
    data: '12/03/2026',
    pendencias: 'Sem pendências.',
    observacoes: 'Rótulo aprovado após conferência final.',
    historico: [
      { data: '10/03/2026 11:20', titulo: 'Envio', descricao: 'Rótulo submetido pelo estabelecimento.' },
      { data: '11/03/2026 15:45', titulo: 'Análise', descricao: 'Conferência de layout e dizeres legais.' },
      { data: '12/03/2026 09:15', titulo: 'Deferimento', descricao: 'Rótulo liberado para uso.' }
    ]
  },
  {
    id: 4,
    municipioId: 3,
    municipio: 'Balneário Arroio do Silva',
    tipo: 'PROCESSO_ADMINISTRATIVO',
    numeroProcesso: 'PROC-2026/0055',
    estabelecimento: 'Pescados Costa Azul',
    referencia: 'Regularização documental',
    situacao: 'INDEFERIDO',
    responsavel: 'Supervisão Regional',
    data: '14/03/2026',
    pendencias: 'Documentação incompatível com a atividade requerida.',
    observacoes: 'Processo encerrado com indeferimento.',
    historico: [
      { data: '09/03/2026 13:40', titulo: 'Abertura', descricao: 'Processo administrativo instaurado.' },
      { data: '12/03/2026 10:00', titulo: 'Parecer', descricao: 'Emitido parecer técnico desfavorável.' },
      { data: '14/03/2026 17:10', titulo: 'Encerramento', descricao: 'Processo indeferido.' }
    ]
  }
])

const itemSelecionado = ref(null)

const listaFiltrada = computed(() => {
  return lista.value.filter(item => {
    const filtroMunicipio = !filtros.idMunicipio || item.municipioId === Number(filtros.idMunicipio)
    const filtroTipo = !filtros.tipo || item.tipo === filtros.tipo
    const filtroSituacao = !filtros.situacao || item.situacao === filtros.situacao

    const texto = filtros.texto.trim().toLowerCase()
    const filtroTexto =
      !texto ||
      item.numeroProcesso.toLowerCase().includes(texto) ||
      item.estabelecimento.toLowerCase().includes(texto) ||
      item.referencia.toLowerCase().includes(texto) ||
      item.municipio.toLowerCase().includes(texto)

    return filtroMunicipio && filtroTipo && filtroSituacao && filtroTexto
  })
})

const indicadores = computed(() => {
  const dados = listaFiltrada.value
  return {
    total: dados.length,
    emAnalise: dados.filter(i => i.situacao === 'EM_ANALISE').length,
    pendentes: dados.filter(i => i.situacao === 'PENDENTE').length,
    deferidos: dados.filter(i => i.situacao === 'DEFERIDO').length
  }
})

function aplicarFiltros() {
  if (listaFiltrada.value.length > 0) {
    itemSelecionado.value = listaFiltrada.value[0]
  } else {
    itemSelecionado.value = null
  }
}

function limparFiltros() {
  filtros.idMunicipio = ''
  filtros.tipo = ''
  filtros.situacao = ''
  filtros.texto = ''
  itemSelecionado.value = lista.value[0] || null
}

function selecionarItem(item) {
  itemSelecionado.value = item
}

function formatarTipo(tipo) {
  const mapa = {
    ESTABELECIMENTO: 'Registro de Estabelecimento',
    PRODUTO: 'Registro de Produto',
    ROTULO: 'Registro de Rótulo',
    PROCESSO_ADMINISTRATIVO: 'Processo Administrativo'
  }
  return mapa[tipo] || tipo
}

function formatarSituacao(situacao) {
  const mapa = {
    EM_ANALISE: 'Em análise',
    PENDENTE: 'Pendente',
    DEFERIDO: 'Deferido',
    INDEFERIDO: 'Indeferido',
    CANCELADO: 'Cancelado'
  }
  return mapa[situacao] || situacao
}

function statusClass(situacao) {
  return {
    'status-analise': situacao === 'EM_ANALISE',
    'status-pendente': situacao === 'PENDENTE',
    'status-deferido': situacao === 'DEFERIDO',
    'status-indeferido': situacao === 'INDEFERIDO',
    'status-cancelado': situacao === 'CANCELADO'
  }
}

itemSelecionado.value = lista.value[0]
</script>

<style scoped>
.form-edit-page {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #f5f7fb;
}

.page-header h1 {
  margin: 0;
  font-size: 24px;
  color: #1f2937;
}

.page-header p {
  margin: 6px 0 0;
  color: #6b7280;
}

.form-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 14px;
}

.row {
  display: flex;
  gap: 14px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.row-actions {
  margin-bottom: 0;
}

.field {
  display: flex;
  flex-direction: column;
  min-width: 220px;
  flex: 1;
}

.field-grow {
  flex: 2;
}

.field label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.field input,
.field select,
.field textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  background: #fff;
  color: #111827;
  box-sizing: border-box;
}

.field textarea {
  resize: vertical;
}

.btn {
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.btn-primary {
  background: #2563eb;
  color: white;
}

.btn-secondary {
  background: #e5e7eb;
  color: #111827;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.kpi-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 18px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.kpi-title {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
}

.kpi-value {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
}

.table-wrapper {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th {
  background: #f3f4f6;
  color: #374151;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.data-table td {
  padding: 12px;
  border-bottom: 1px solid #eef2f7;
  font-size: 14px;
  color: #111827;
}

.data-table tbody tr {
  cursor: pointer;
  transition: background 0.2s ease;
}

.data-table tbody tr:hover {
  background: #f9fafb;
}

.data-table tbody tr.selected {
  background: #eff6ff;
}

.empty-row {
  text-align: center;
  color: #6b7280;
}

.status-pill {
  display: inline-flex;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.status-analise {
  background: #dbeafe;
  color: #1d4ed8;
}

.status-pendente {
  background: #fef3c7;
  color: #b45309;
}

.status-deferido {
  background: #dcfce7;
  color: #15803d;
}

.status-indeferido {
  background: #fee2e2;
  color: #b91c1c;
}

.status-cancelado {
  background: #e5e7eb;
  color: #4b5563;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.detail-box {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
}

.detail-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
}

.detail-value {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.subsection {
  margin-top: 12px;
}

.subsection h3 {
  font-size: 15px;
  margin: 0 0 12px;
  color: #111827;
}

.timeline {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.timeline-item {
  display: flex;
  gap: 12px;
  padding: 10px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.timeline-date {
  min-width: 130px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
}

.timeline-content p {
  margin: 4px 0 0;
  color: #374151;
  font-size: 13px;
}

@media (max-width: 1200px) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .detail-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .kpi-grid,
  .detail-grid {
    grid-template-columns: 1fr;
  }

  .timeline-item {
    flex-direction: column;
  }

  .timeline-date {
    min-width: auto;
  }
}
</style>